import { useGlobalContext } from '../context'

function Vampire() {
    const { players, index, slay, vote, openWaitingScreen, stacks} = useGlobalContext();
    let currentPlayer = players[index];
    console.log(stacks)
    return (
        <div className='container border border-dark'>
            <h4 className='text-center'>{currentPlayer.name}(Warrior)</h4>
            <p className='text-center'>You are a veteran, ruthless warrior who has served the royal family for years.Now your path crosses this small village.
            But of course,if it was a regular village, you wouldn't be in this game.This village is haunted by vampires and you will do your best to save the villagers.
            Each round you don't die, you gain stacks.After you have four stacks, you can start killing vampires!</p>
            <div className='d-flex'>
                <img src={`./img/${currentPlayer.class}.png`} alt="" />
                <div className='btn-holder'>{
                    players.map((player, index) => {
                        if (stacks > 3 && (player.class === 'vampire' || player.class === 'foolvampire' || player.class === 'dracula'))
                            return (<button disabled={vote ? 'disabled' : ''} className='btn btn-danger border' onClick={(e) => { slay(index); e.target.classList.add('selected')}} key={index}>{player.name}</button>)
                    })
                }
                </div>
            </div>
            <button className='btn btn-dark next' onClick={() => openWaitingScreen(index)}>Next</button>
        </div>
    )
}

export default Vampire;